import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { BaseAddComponent } from '../base-add/base-add.component';
import { fuseAnimations } from '@mobileia/layout-fuse';
import { AlertService } from 'src/app/services/alert.service';
import { HelpboxService } from 'src/app/services/helpbox.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-helpbox-add',
  templateUrl: './helpbox-add.component.html',
  styleUrls: ['./helpbox-add.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations
})
export class HelpboxAddComponent extends BaseAddComponent<any> implements OnInit {

  pathUrlList = 'helpbox';

  constructor(
    protected helpService: HelpboxService,
    protected alertService: AlertService,
    protected route: ActivatedRoute,
    protected navigator: Router
  ) {
    super(alertService, route, navigator);
    this.service = helpService;
    this.item = {};
    this.initFields();
  }

  initFields() {
    this.configFields = [
      {
        type: 'string',
        key: 'title',
        title: 'Titulo',
        caption: ''
      },
      {
        type: 'text',
        key: 'caption',
        title: 'Descripción',
        caption: ''
      }
    ];
  }

  removeQuestion(quest) {
    let index = this.item.questions.indexOf(quest);
    if (index > -1) {
      this.item.questions.splice(index, 1);
    }
  }

  addQuestion() {
    this.item.questions.push({ title: '', caption: ''});
  }
}
